import { render, staticRenderFns } from "./SuppressedItemsModal.vue?vue&type=template&id=4c16b77b&scoped=true&"
import script from "./SuppressedItemsModal.vue?vue&type=script&lang=js&"
export * from "./SuppressedItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./SuppressedItemsModal.vue?vue&type=style&index=0&id=4c16b77b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c16b77b",
  null
  
)

export default component.exports